import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Roles, Status, Types } from "../../../../../utils/enums"
import { useStyles } from "../styles"
import { Box, Checkbox, Icon, List, ListItem, Tooltip, Typography } from "@mui/material"
import { getLocalStorage } from "../../../../../utils/crud/crypt"
import { HeaderRowCheckBox } from "../../../../calendar/pages/main/components/headerRowCheckBox"
import { icons } from "../../../../../utils/icons"
import { getStatus } from "../../../../../hooks/status"
import StatusComponent from "../../../../../components/status"
import { useContextState } from "../../../../../hooks/theme"
import { RowItem } from "../../../../../service/filesManager/response"
import { formatFilesList } from "../../../../../service/filesManager/format"
import { returnQueryWithPagination } from "../../../../../utils/methods/returnQuery"
import { formData } from "../../main/components/allFiles/constans/format"
import { GridPaginationModel } from "@mui/x-data-grid"
import { filesManagerServiceFetch } from "../../../../../utils/constants/callService"
import { FilesManagerContext } from "../../../context"
import { updatePermisisonBodyMassive } from "../../../../../service/filesManager/body"

const useBody = ({ userFolioSelected }: {
    userFolioSelected: Record<string, {
        seeFile?: boolean;
        downloadFile?: boolean;
    }>
}) => {

    const navigate = useNavigate()
    const { t } = useTranslation()
    const [errors, setErrors] = useState<Record<string, string>>({})
    const styles = useStyles()
    const { selectedIds, notFileSelected, filterFileMain, isChecked } = useContext(FilesManagerContext)
    //const [loadingDetail, setLoadingDetail] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)
    const [loadingPermission, setLoadinPermission] = useState(false)
    const [totalPages, setTotalPages] = useState(0)
    const [row, setRow] = useState<RowItem[]>([])
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 1,
        pageSize: 20,
    })
    const [totalSelected, setTotalSelected] = useState(0)
    const [isCheckedAll, setIsCheckedAll] = useState<boolean>(true)
    const [notSelectedFile, setNotSelectedFile] = useState<number[]>([])
    const [fileSelected, setFileSelected] = useState<number[]>([])
    const { colors } = useContextState()
    const state: { id: number, role: number } = getLocalStorage()
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const handleCancelPermission = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.cancelPermissionConfiguration'),
            confirm: () => { navigate('/dashboard/filesManager/main'); }
        }))
    }

    const handleSubmitPermission = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.savePermissionConfigurationMassive'),
            confirm: () => {
                closeModalIndex();
                handleEditPermissions();
            }
        }))
    }

    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })

    const goBackToList = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.backToList'),
            description: t('filesManager.modal.description.toBackTheChangesLost'),
            confirm: () => { navigate('/dashboard/filesManager/main'); }
        }))
    }

    const closeModalIndex = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const handlePagination = (data: GridPaginationModel) => {
        const newData = {
            page: data.page,
            pageSize: data.pageSize,
        }

        setPaginationModel(newData)
    }

    const handleEditPermissions = async () => {
        setLoadinPermission(true)
        const body = updatePermisisonBodyMassive({ userPermissions: userFolioSelected, isChecked, fileSelected, isCheckedAll, selectedIds, notSelectedFile, notFileSelected })
        
        const response = await filesManagerServiceFetch.updateFilePermissionMassive({ body, query: `created_by_me=true&created_by_me_only_active=false${returnQueryWithPagination({ ...filterFileMain.query, filter: filterFileMain.query.filter?.replaceAll('+', '%2B') }, formData)}` })
        if (!response.errors) {
            setOpenSnackbar({ ...openSnackbar, open: true, message: t('filesManager.snackbar.updatePermissions.success'), type: Types.SUCCESS })
            setTimeout(() => {
                navigate('/dashboard/filesManager/main');
            }, 3000);
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: t('filesManager.snackbar.updatePermissions.error'), type: Types.ERROR })
        }
        setLoadinPermission(false)
    }

    const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFileSelected([]);
        setNotSelectedFile([]);
        if (event.target.checked) {
            setIsCheckedAll(true)
        } else {
            setIsCheckedAll(false)
        }
    };

    const column = [
        {
            field: 'checkbox',
            headerName: '',
            headerCell: styles?.mineHeaderTable,
            label: (
                <Checkbox
                    checked={isCheckedAll}
                    onChange={handleHeaderChange}
                    color="primary"
                />
            ),
            renderCell: (params: any) => {
                //const validation = !!(params.row.createById !== state.id) && state.role !== Roles.ADMIN
                const isMine = params.row.createdBy == state.id
                const isMineOrAdmin = params.row.createdBy == state.id || state.role == Roles.ADMIN
                return (<>
                    {isMineOrAdmin &&
                        <Box sx={styles.flex}>
                            <HeaderRowCheckBox
                                id={params.row.id}
                                isChecked={isCheckedAll}
                                selectedIds={fileSelected}
                                setSelectedIds={setFileSelected}
                                notFolioSelected={notSelectedFile}
                                setNotFolioSelected={setNotSelectedFile}
                                disabled={false}
                            />

                            {isMine &&
                                <Tooltip title={t('filesManager.titles.mineFile')}>
                                    <Box sx={styles.circle} />
                                </Tooltip>
                            }
                        </Box>
                    }
                </>)
            }
        },
        {
            id: 'area',
            label: t('filesManager.columns.area'),
            headerCell: styles?.headerTable,
            renderCell: (params: any) => {
                const areaArray = params.row.area ? params.row.area : undefined;
                const firstTwoArea = areaArray?.slice(0, 2);
                const remainingArea = areaArray?.slice(2);
                return (
                    <Box>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoArea?.join(', ')}
                            {remainingArea?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingArea.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!areaArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'department',
            label: t('filesManager.columns.department'),
            headerCell: styles?.headerTable,
            renderCell: (params: any) => {
                const departmentArray = params.row.department ? params.row.department : undefined;
                const firstTwoDepartment = departmentArray?.slice(0, 2);
                const remainingDepartment = departmentArray?.slice(2);
                return (
                    <Box>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoDepartment?.join(', ')}
                            {remainingDepartment?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingDepartment.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!departmentArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'fileName',
            label: t('filesManager.columns.fileName'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'createTime',
            label: t('filesManager.columns.creationDate'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'solicitedUsers',
            label: t('filesManager.columns.solicitedUsers'),
            headerCell: styles?.headerTable,
            renderCell: (params: any) => {
                const usersArray = params.row.solicitedUsers ? params.row.solicitedUsers : undefined;
                const firstTwoUsers = usersArray?.slice(0, 1);
                const remainingUsers = usersArray?.slice(1);
                return (
                    <Box>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoUsers?.join(', ')}
                            {remainingUsers?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingUsers.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!usersArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'type',
            label: t('filesManager.columns.type'),
            headerCell: styles?.headerTable,
            //sortable: true
        },
        {
            id: 'size',
            label: t('filesManager.columns.size'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'status',
            label: t('filesManager.columns.status'),
            headerCell: styles?.headerTable,
            //sortable: true,
            renderCell: (params: any) => {
                const status = getStatus(params?.row?.status as Status == Status.CLOSE ? Status.CANCEL : params?.row?.status, colors, t,)
                return (
                    <StatusComponent color={status.color} msg={status.text} size='small' />
                )
            }
        }
    ]

    const getFilesList = async () => {
        setTableLoading(true)
        const response = await filesManagerServiceFetch.getListFilesMassive({ query: `page=${paginationModel.page}&size=${paginationModel.pageSize}&created_by_me=true&created_by_me_only_active=false${returnQueryWithPagination({ ...filterFileMain.query, filter: filterFileMain.query.filter?.replaceAll('+', '%2B') }, formData)}`, body: { allFiles: isChecked, ids: isChecked ? notFileSelected : selectedIds } })
        const { row } = formatFilesList({ response })

        if (!response?.errors) {
            setRow(row)
            setTotalPages(response.totalPages)
            setTotalSelected(response.totalItems)
        }

        setTableLoading(false)
    }

    useEffect(() => {

        getFilesList()

    }, [paginationModel])

    return {
        goBackToList,
        errors,
        setErrors,
        modal,
        closeModalIndex,
        handleSubmitPermission,
        handleCancelPermission,
        openSnackbar,
        handleCloseSnackbar,
        handleEditPermissions,
        loadingPermission,
        column,
        tableLoading,
        row,
        totalPages,
        handlePagination,
        paginationModel,
        totalSelected,
        isCheckedAll,
        fileSelected,
        notSelectedFile
    }
}

export { useBody }
